"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var Arrow = function Arrow(_ref) {
  var direction = _ref.direction,
    onClick = _ref.onClick,
    areSlideFeaturesVisible = _ref.areSlideFeaturesVisible;
  var arrowIconDirection = direction === 'next' ? 'icon-arrow-2-e' : 'icon-arrow-2-w';
  return /*#__PURE__*/_react.default.createElement("div", {
    onClick: onClick,
    className: "ac-collection-".concat(direction, " ").concat(areSlideFeaturesVisible, " ").concat(arrowIconDirection)
  });
};
Arrow.propTypes = {
  direction: _propTypes.default.string,
  onClick: _propTypes.default.func,
  areSlideFeaturesVisible: _propTypes.default.string
};
var _default = exports.default = Arrow;